import { useSelector } from 'react-redux';

import { IAppState, IAuthState } from './../interfaces/state';

export const useAuthUser = () => {
  const { authUser } = useSelector<IAppState, IAuthState>(state => state.auth);
  return authUser;
}